export interface ProductRouteLike {
  slug?: string | null;
  canonical_path?: string | null;
  partNumber?: string | null;
  seo_part_number?: string | null;
  part_number?: string | null;
}

export const isProductDetailPath = (path?: string | null): boolean =>
  !!path && path.startsWith("/productos/");

const normalizeRoutePath = (value?: string | null): string | null => {
  if (!value) {
    return null;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  return trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
};

export const normalizeSeoPartNumber = (
  partNumber?: string | null,
): string | null => {
  if (!partNumber) {
    return null;
  }

  const normalized = partNumber
    .trim()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/\./g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-{2,}/g, "-")
    .replace(/^-+|-+$/g, "");

  return normalized || null;
};

export const getProductRouteParams = (product: ProductRouteLike) => {
  const partNumber =
    product.partNumber ||
    product.seo_part_number ||
    normalizeSeoPartNumber(product.part_number);
  if (!partNumber) {
    return null;
  }

  return product.slug
    ? { partNumber, slug: product.slug }
    : { partNumber, slug: undefined };
};

export const getProductRouteLocation = (product: ProductRouteLike) => {
  const canonicalPath = normalizeRoutePath(product.canonical_path);
  if (canonicalPath) {
    return { path: canonicalPath };
  }

  const params = getProductRouteParams(product);
  if (params && params.slug && params.partNumber) {
    return {
      path: `/productos/${params.partNumber}/${params.slug}`,
    };
  }

  const legacySlug = product.slug || product.part_number || "";

  return {
    path: `/productos/${legacySlug}`,
  };
};
